import React from 'react';
import Button from './Button';

const ProjectFilter = ({ options, selected, onSelect }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '0.75rem',
        marginBottom: '2rem',
        fontWeight: '500',
      }}
    >
      {options.map((option) => {
        const isActive = selected === option;

        return (
          <Button
            key={option}
            label={option}
            onClick={() => onSelect(option)}
            base="transparent"
            hover="#c026d3"
            pressed="#a21caf"
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '999px',
              border: '1px solid #c026d3',
              backgroundColor: isActive ? '#c026d3' : 'transparent',
              color: isActive ? '#fff' : '#a5b4fc',
              fontWeight: 500,
              width: 'auto',
              boxShadow: isActive ? '0 0 0 1px #f9a8d4' : 'none',
            }}
          />
        );
      })}
    </div>
  );
};

export default ProjectFilter;
